const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/vendors`,
    search: `${API_URL}/vendor/search`,
    information: `${API_URL}/vendor/information`,
};

export default apiUrls;
